import React from 'react';
import { Page, View, Text, Image } from '@react-pdf/renderer';
import { type, colors, page as pageGeom, space } from '../theme';

// Single Page wrapper for the whole report. Banner + footer use the `fixed`
// prop so they repeat on every physical page that @react-pdf produces as the
// content overflows. Content flows naturally — sections sit one after the
// next, with page breaks happening wherever the content overflows.
const BANNER_HEIGHT = 50;
const FOOTER_HEIGHT = 28;

const PageFrame = ({ children, variant }) => (
  <Page size="LETTER" style={{
    fontFamily: 'Montserrat',
    backgroundColor: '#ffffff',
    paddingTop: BANNER_HEIGHT + space.lg,
    paddingBottom: FOOTER_HEIGHT + space.lg,
    paddingHorizontal: pageGeom.margin,
  }}>
    {/* Banner — repeats on every page */}
    <View fixed style={{
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
    }}>
      <View style={{
        flexDirection: 'row',
        alignItems: 'center',
        paddingHorizontal: pageGeom.margin,
        paddingVertical: 12,
        backgroundColor: colors.bannerDark,
      }}>
        <Text style={{
          fontFamily: 'Montserrat',
          fontWeight: 700,
          fontSize: 16,
          letterSpacing: 1.4,
          color: '#ffffff',
        }}>
          MULTIPLY
        </Text>
        <Image
          src="/images/multiply-icon.png"
          style={{ width: 20, height: 'auto', marginLeft: 10, marginRight: 10 }}
        />
        <View style={{ width: 4, height: 4, borderRadius: 2, backgroundColor: colors.teal, marginRight: 10 }} />
        <Text style={{
          fontFamily: 'Montserrat',
          fontWeight: 400,
          fontSize: 9.5,
          color: '#cfd8dc',
          flex: 1,
        }}>
          {variant === 'shared' ? 'Sales meeting recap' : 'Sales meeting performance analysis'}
        </Text>
        <Text
          style={{
            fontFamily: 'Montserrat',
            fontWeight: 500,
            fontSize: 9.5,
            color: '#cfd8dc',
          }}
          render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`}
        />
      </View>
      <View style={{ height: 4, backgroundColor: colors.teal }} />
    </View>

    {/* Page content flows here */}
    <View>{children}</View>

    {/* Footer — repeats on every page */}
    <View fixed style={{
      position: 'absolute',
      bottom: 0,
      left: pageGeom.margin,
      right: pageGeom.margin,
      paddingTop: space.sm,
      paddingBottom: 12,
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
    }}>
      <Text style={[type.micro, { color: colors.teal, fontWeight: 600 }]}>
        Multiply <Text style={{ color: colors.muted, fontWeight: 400 }}> · askmultiply.com</Text>
      </Text>
      <Text style={[type.micro, { color: colors.muted }]}>
        Confidential · {variant === 'shared' ? 'Prospect copy' : 'Internal review'}
      </Text>
    </View>
  </Page>
);

export default PageFrame;
